<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-01 23:09:12
 * @LastEditors: ???
 * @LastEditTime: 2022-05-03 19:23:05
-->
<template>
  <div class="wrapper">
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="visible"
      width="30%"
      @close="close"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="80px"
        :inline="false"
        size="normal"
      >
        <el-form-item label="订单编号">
          <el-input :value="form.orderNo" readonly></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input :value="form.phone" readonly></el-input>
        </el-form-item>
        <el-form-item label="预约时间">
          <el-input :value="form.appointmentTimeEnd" readonly></el-input>
        </el-form-item>
        <el-form-item label="约单类型">
          <el-input :value="form.cate == 0 ? '预约订单' : form.cate == 1 ? '交投单' : form.cate == 2 ? '帮约单' : '自助驿站'" readonly></el-input>
        </el-form-item>
        <el-form-item label="订单类型">
          <el-input :value="form.orderType == 1 ? '可回收物' : form.orderType == 2 ? '家电回收' : ''" readonly></el-input>
        </el-form-item>
        <el-form-item label="签收重量" v-if="form.orderType == 1">
          <el-input :value="form.actualWeight" readonly></el-input>
        </el-form-item>
        <el-form-item label="卖出家电清单" v-else>
          <el-input :value="form.hapName" readonly></el-input>
        </el-form-item>
        <el-form-item label="签收金额">
          <el-input :value="form.totalPrice" readonly></el-input>
        </el-form-item>
        <el-form-item label="用户地址">
          <el-input :value="form.wlUserAddress ? form.wlUserAddress + form.wlUserAddressDetail : '--'" readonly></el-input>
        </el-form-item>
        <el-form-item label="回收照片">
          <template v-if="form.orderPic">
            <el-image
              v-for="(item, i) in form.orderPic"
              style="width: 100px; height: 50px; margin: 0 10px;"
              :src="item"
              :preview-src-list="[item]"
              :key="i"
            >
              <div slot="error" class="image-slot" style="width: 100px; height: 50px">
                <img src="@/assets/imgFail.png" alt style="width: 60px; height: 40px" />
              </div>
            </el-image>
          </template>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="form.userRemark"
            type="textarea"
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item label="回收员">
          <el-input :value="form.wlRecycleUserNmae" readonly></el-input>
        </el-form-item>
        <el-form-item label="签收时间">
          <el-input :value="form.signInTime" readonly></el-input>
        </el-form-item>
        <template v-if="form.circulationStatus == 3">
          <div v-for="(item, index) in form.auditList" :key="index">
            <div style="border: 1px solid #000; margin-bottom: 15px;"></div>
            <el-form-item label="扣减时间">
              <el-input :value="item.createTime" readonly></el-input>
            </el-form-item>
            <el-form-item label="错误重量">
              <el-input :value="item.errorWeight" readonly></el-input>
            </el-form-item>
            <el-form-item label="单价环保金">
              <el-input :value="item.unitPrice" readonly></el-input>
            </el-form-item>
            <el-form-item label="总环保金">
              <el-input :value="item.totalPrice" readonly></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                v-model="form.applyRemark"
                type="textarea"
                readonly
              ></el-input>
            </el-form-item>
            <el-form-item label="回收照片">
              <template v-if="item.picUrl">
                <el-image
                  v-for="i in item.picUrl"
                  style="width: 100px; height: 50px; margin: 0 10px;"
                  :src="i"
                  :preview-src-list="[i]"
                  :key="i"
                >
                  <div slot="error" class="image-slot" style="width: 100px; height: 50px">
                    <img src="@/assets/imgFail.png" alt style="width: 60px; height: 40px" />
                  </div>
                </el-image>
              </template>
            </el-form-item>
          </div>
        </template>
      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import { httpAction } from '@/api/manage';
import { listMixin } from '@/mixins/listMixin';

export default {
  components: {},
  mixins: [listMixin],
  props: {},
  data() {
    return {
      disableMixinCreated: true,
      title: '操作',
      visible: false,
      confirmLoading: false,
      form: {},
    };
  },
  watch: {},
  computed: {},
  methods: {
    edit(record) {
      console.log("🚀 ~ edit ~ record:", record)
      httpAction("/user/statistical/detail?orderId=" + record.orderId, {}, "post").then( res => {
        if (res.code == 200) {
          this.form = res.data;
          this.visible = true;
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    close() {
      this.$refs.form.resetFields();
      this.$emit('close');
      this.visible = false;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.wrapper {
}
</style>
